<main id="main-content" class="ds-product-page accessibility-page">
  <header>
    <p class="ds-eyebrow">Display preferences</p>
    <h1>Make IQLabTest comfortable for you</h1>
    <p>
      These settings apply across the website and stay on this device. They do not change your
      assessment score or time limit.
    </p>
  </header>
  <section dsCard class="settings-card" aria-labelledby="text-size-title">
    <div>
      <h2 id="text-size-title">Text size</h2>
      <p>Increase interface and article text without relying on browser zoom.</p>
    </div>
    <div class="segmented" role="radiogroup" aria-labelledby="text-size-title">
      @for (
        size of [
          { value: 'default', label: 'Default' },
          { value: 'large', label: 'Large' },
          { value: 'extra-large', label: 'Extra large' },
        ];
        track size.value
      ) {
        <button
          type="button"
          role="radio"
          [attr.aria-checked]="preferences().textSize === size.value"
          [class.active]="preferences().textSize === size.value"
          (click)="service.update({ textSize: $any(size.value) })"
        >
          {{ size.label }}
        </button>
      }
    </div>
  </section>
  <section dsCard class="settings-card" aria-labelledby="visual-title">
    <div>
      <h2 id="visual-title">Visual and motion settings</h2>
      <p>Choose stronger separation, calmer transitions, or a more focused assessment view.</p>
    </div>
    <div class="toggle-list">
      <label
        ><input
          dsCheckbox
          type="checkbox"
          [checked]="preferences().highContrast"
          (change)="service.update({ highContrast: $any($event.target).checked })"
        /><span
          ><strong>Higher contrast</strong
          ><small>Strengthens text, border, and focus contrast.</small></span
        ></label
      >
      <label
        ><input
          dsCheckbox
          type="checkbox"
          [checked]="preferences().reduceMotion"
          (change)="service.update({ reduceMotion: $any($event.target).checked })"
        /><span
          ><strong>Reduce motion</strong
          ><small>Removes optional transitions and smooth scrolling.</small></span
        ></label
      >
      <label
        ><input
          dsCheckbox
          type="checkbox"
          [checked]="preferences().focusMode"
          (change)="service.update({ focusMode: $any($event.target).checked })"
        /><span
          ><strong>Assessment focus mode</strong
          ><small>Hides non-essential navigation while answering questions.</small></span
        ></label
      >
    </div>
  </section>
  <section class="accessibility-actions">
    <button dsButton variant="secondary" type="button" (click)="service.reset()">
      Reset preferences</button
    ><a dsButton href="/">Return to assessment</a>
  </section>
  <p class="accessibility-note">
    IQLabTest also supports keyboard navigation, visible focus indicators, semantic headings, and
    the operating system’s reduced-motion preference.
  </p>
</main>
